import {create} from 'zustand';

interface SelectedRun {
  name: string;
  displayName: string;
}

interface WBAgentContextState {
  // Chat window visibility
  open: boolean;
  setOpen: (open: boolean) => void;

  // Run context
  selectedRuns: SelectedRun[];
  projectName: string | undefined;
  addRun: (run: SelectedRun) => void;
  removeRun: (name: string) => void;
  clearRuns: () => void;
  syncProject: (projectName: string | undefined) => void;
}

export const useWBAgentContextStore = create<WBAgentContextState>()(set => ({
  open: false,
  setOpen: open => set({open}),
  selectedRuns: [],
  projectName: undefined,
  addRun: run =>
    set(state => {
      if (state.selectedRuns.some(r => r.name === run.name)) {
        return state;
      }
      return {selectedRuns: [...state.selectedRuns, run]};
    }),
  removeRun: name =>
    set(state => ({
      selectedRuns: state.selectedRuns.filter(r => r.name !== name),
    })),
  clearRuns: () => set({selectedRuns: []}),
  syncProject: projectName =>
    set(state => {
      if (state.projectName === projectName) {
        return state;
      }
      return {projectName, selectedRuns: []};
    }),
}));
